
import {MetricService} from "@/services/metric-service";
import {ApexOptions} from "apexcharts";
import Vue from "vue";
import {setTitle, resetTitle} from "@/utils/title";
import AppDemoStatistics from "@/components/DemoStatistics.vue";
import AppSaleStatistics from "@/components/SalesStatistics.vue";
import AppInstallationsStatistics from "@/components/InstallationsStatistics.vue";

export default Vue.extend({
	data() {
		return {
			MetricService,
			initialSeries: [] as any[],
			filters: {
				requests: true,
				pdfs: true,
				clients: true,
				runningJobs: true,
				queuedJobs: true
			},
			selectedTab: 0,
		};
	},
	computed: {
		tabs(): string[] {
			return ["Demo's","Cijfers", "Installaties"];
		},
		// eslint-disable-next-line max-lines-per-function
		chartOptions(): ApexOptions {
			return {
				chart: {
					animations: {
						enabled: false
					}
				},
				xaxis: {
					labels: {
						show: false
					},
					title: {
						text: "Time"
					}
				},
				yaxis: {
					title: {
						text: "Count"
					},
					min: 0,
					forceNiceScale: true
				},
				dataLabels: {
					enabled: false
				}
			};
		},
	},
	watch: {},
	methods: {},
	created() {
		setTitle("Demo's");
	},
	async mounted() {
	},
	destroyed() {
		resetTitle();
	},
	components: {
		AppDemoStatistics,
		AppSaleStatistics,
		AppInstallationsStatistics
	}
});
